import { FieldPath, FieldValues } from 'react-hook-form';

import { TextField, TextFieldProps } from '.';


export function CurrencyField<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(props: TextFieldProps<TFieldValues, TName>) {
    return (
        <TextField
            {...props}
            maskProps={{
                thousandsGroupStyle: 'thousand',
                prefix: '$',
                decimalScale: 2,
                decimalSeparator: '.',
                displayType: 'input',
                thousandSeparator: true,
                allowNegative: true,
                ...props.maskProps
            }}
        />
    );
}
